import React from "react";
import AppSplash from "../../../components/AppSplash";
import AccessDenied from "./AccessDenied";
import { useAccess } from "../context/AccessProvider";

export default function RequirePermission({ permission, children }) {
  const { status, can } = useAccess();
  if (status === "loading" || status === "idle") return <AppSplash />;
  if (!can(permission)) return <AccessDenied />;
  return children;
}
